"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlatformAidRefSchema = exports.PlatformAdGroupRefSchema = exports.PlatformDeviceRefSchema = exports.PlatformCampaignRefSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.PlatformCampaignRefSchema = typebox_1.Type.String();
exports.PlatformDeviceRefSchema = typebox_1.Type.String();
exports.PlatformAdGroupRefSchema = typebox_1.Type.String();
exports.PlatformAidRefSchema = typebox_1.Type.String();
